import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class TranslateArrayService {

    constructor(
        public translate: TranslateService,
    ) {


    }

    /**
     * @description get translate
     * @return {any}
     */
    get(paginator: any) {
       
       
        if (paginator && paginator._intl) {
            paginator._intl.firstPageLabel = this.translate.instant('matTable.firstPageLabel');
            paginator._intl.itemsPerPageLabel = this.translate.instant('matTable.itemsPerPageLabel');
            paginator._intl.nextPageLabel = this.translate.instant('matTable.nextPageLabel');
            paginator._intl.previousPageLabel = this.translate.instant('matTable.previousPageLabel');
            paginator._intl.lastPageLabel = this.translate.instant('matTable.lastPageLabel');
            paginator._intl.getRangeLabel = this.Label;
        }

        return paginator;
    }
    /**
      * @description  set le label
      * @return {any}
      */

    Label = (page: number, pageSize: number, length: number) => {


        if (length == 0 || pageSize == 0) { return `0 ${this.translate.instant('matTable.of')} ${length}`; }

        length = Math.max(length, 0);

        const startIndex = page * pageSize;

        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;

        return `${startIndex + 1} - ${endIndex} ${this.translate.instant('matTable.of')} ${length}`;
    }




}
